// in src/Dashboard.js
import React, { useState } from 'react';




import Grid from '@mui/material/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@mui/material/Typography';


import IconCancel from '@material-ui/icons/Cancel';

//import {List as ListMaterial} from '@mui/material/List';
import ListMaterial from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import {
  List, 
  Datagrid,
  TextField,
  Button, 
  TopToolbar,DateField ,DateInput,NumberInput,  FunctionField, ResourceContextProvider, useRefresh, FormWithRedirect, SaveButton, useDataProvider, NumberField,
  ReferenceArrayInput,
  SelectArrayInput,
  useNotify, 
  downloadCSV,
  BooleanInput, 
  RadioButtonGroupInput, ReferenceInput, SelectInput, required
  
} from 'react-admin';

import jsonExport from 'jsonexport/dist';

import { ExportButton } from './../components/ExportButton';

import { datesLastMonth, dateOnlyToCatalan, DatagridNoResults, subscriptionModule,
  headersAPIObjectAuth } from './../common/utils';
import { apiUrl, modules, modulesOptions  } from './../common/constants';


import { parse } from 'query-string';




import { useTranslate  } from '../common/language';



import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import ListAltIcon from '@mui/icons-material/ListAlt';





import {useHistory} from 'react-router-dom';


import { UserFullNameTxt } from '../components/User';

import { DonationsProjectsList, DonationsPaymentsList } from '../resources/donations_projects';
import { DonationsUsersList } from '../resources/donations_users';
import { DonationsCertificatesList } from '../resources/donations_certificates';


export const Reports = props => {
    
  const [openAnnuaryDialog, setOpenAnnuaryDialog] = useState(false);
  const [openResponsabilitiesDialog, setOpenResponsabilitiesDialog] = useState(false);
  const [openLeftMembersDialog, setOpenLeftMembersDialog] = useState(false);
  const [openDonationsPaymentsDialog, setOpenDonationsPaymentsDialog] = useState(false);
  const [openDonationsProjectsDialog, setOpenDonationsProjectsDialog] = useState(false);
  const [openDonationsCertificatesDialog, setOpenDonationsCertificatesDialog] = useState(false);
  const [openDonationsModel182Dialog, setOpenDonationsModel182Dialog] = useState(false);
  const [model182FiscalYears, setModel182FiscalYears] = useState([]);
  const [model182FiscalYearsLoading, setModel182FiscalYearsLoading] = useState(false);
  const [model182FiscalYearsError, setModel182FiscalYearsError] = useState();
    
  const translate = useTranslate(); 
  const dataProvider = useDataProvider();
  const history = useHistory();
    
  const year = new Date().getFullYear() - 1;
  var today = new Date();
  
  const datesLastMonthStc = datesLastMonth();
        
  const handleClick = () => {
    setOpenAnnuaryDialog(true);
  };

  const handleCloseClick = () => {
    setOpenAnnuaryDialog(false);
  };
    
  const handleSubmit = async values => {      
    let last_years = values.last_years ? 1 : 0;
    history.push('/reports/annuary?year=' + values.year + '&last_years=' + last_years );
  };
    
  const handleResponsabilitiesClick = () => {
    setOpenResponsabilitiesDialog(true);
  };

  const handleCloseResponsabilitiesClick = () => {
    setOpenResponsabilitiesDialog(false);
  };
    
  const handleResponsabilitiesSubmit = async values => {                
    var resp = '';
    if (values.responsabilities) 
      resp = values.responsabilities.join(',');
    history.push('/reports/responsabilities?date_query=' + values.date_query + '&responsabilities=' + resp );
  };
  
  
  const handleLeftMembersClick = () => {
    setOpenLeftMembersDialog(true);
  };

  const handleCloseLeftMembersClick = () => {
    setOpenLeftMembersDialog(false);
  };
    
  const handleLeftMembersSubmit = async values => {                    
    history.push('/reports/left_members?groups_id=' + values.groups_id + '&future=' + values.future );
  };
  
  const handleDonationsProjectsClick = async values => {     
    history.push('/reports/donations_projects' );
  };
  
  const handleDonationsTransferValidationsClick = async values => {     
    history.push('/reports/donations_transfer_validations' );
  };
  
  const handleDonationsCertificatesClick = () => {
    setOpenDonationsCertificatesDialog(true);
  };
  const handleCloseDonationsCertificatesClick = () => {
    setOpenDonationsCertificatesDialog(false);
  };
  const handleSubmitDonationsCertificates = async values => {     
    history.push('/reports/donations_certificates/' + values.year );
  };

  const handleDonationsModel182Click = async () => {
    setOpenDonationsModel182Dialog(true);
    setModel182FiscalYearsLoading(true);
    setModel182FiscalYearsError(undefined);
    try {
      const query = new URLSearchParams({
        associations_id: localStorage.getItem('associations_id')
      });
      const response = await fetch(
        `${apiUrl}/donations_certificates/model-182/fiscal-years?${query}`,
        { headers: headersAPIObjectAuth() }
      );
      if (!response.ok) {
        let message = translate('donations_model_182.fiscal_years_error');
        try {
          const responseError = await response.json();
          if (responseError.message) message = responseError.message;
        } catch (ignore) {}
        throw new Error(message);
      }
      const fiscalYears = await response.json();
      setModel182FiscalYears(fiscalYears);
      if (fiscalYears.length === 0) {
        setModel182FiscalYearsError(translate('donations_model_182.no_fiscal_years'));
      }
    } catch (error) {
      setModel182FiscalYears([]);
      setModel182FiscalYearsError(error.message || translate('donations_model_182.fiscal_years_error'));
    } finally {
      setModel182FiscalYearsLoading(false);
    }
  };
  const handleCloseDonationsModel182Click = () => {
    setOpenDonationsModel182Dialog(false);
  };
  const handleSubmitDonationsModel182 = async values => {
    history.push('/reports/donations_model_182/' + values.year);
  };
  
  
  const handleDonationsPaymentsClick = () => {
    setOpenDonationsPaymentsDialog(true);
  };
  const handleCloseDonationsPaymentsClick = () => {
    setOpenDonationsPaymentsDialog(false);
  };
  const handleSubmitDonationsPayments = async values => {     
    history.push('/reports/donations_payments/' + values.date_from + '/' + values.date_to );
  };
  
  const isAdminOrContacts = ['OWNER', 'ADMIN', 'ADMIN_CONTACTS', 'ADMIN_READER'].includes(localStorage.getItem('permissions_groups'));
        
  return (
    <>
      { isAdminOrContacts ? ( 
      
      <>
      <Box sx={{ width: '100%', maxWidth: 500, bgcolor: 'background.paper' }} className="settings_box" >
      
        <ListMaterial>
        
          { subscriptionModule(modules.FEDERATION) ? 
          <ListItem>
            <ListItemButton onClick={handleClick} >
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary={translate('reports.annuary')} secondary={translate('reports.annuary_desc')} />
            </ListItemButton>
          </ListItem>
          : null }
          
          { subscriptionModule(modules.FEDERATION) ? 
          <ListItem>
            <ListItemButton onClick={handleResponsabilitiesClick} >
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary={translate('reports.responsabilities')} secondary={translate('reports.responsabilities_desc')}/>
            </ListItemButton>
          </ListItem>
          : null }
                    
          <ListItem>
            <ListItemButton onClick={handleLeftMembersClick} >
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary={translate('reports.left_members')} secondary={translate('reports.left_members_desc')}/>
            </ListItemButton>
          </ListItem>
                    
          { subscriptionModule(modules.FEDERATION) ? 
          <ListItem>
            <ListItemButton onClick={handleDonationsProjectsClick} >
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary={translate('donations_projects.reports')} secondary={translate('donations_projects.reports_desc')}/>
            </ListItemButton>
          </ListItem>
          : null }
          
          { subscriptionModule(modules.FEDERATION) || subscriptionModule(modules.DONATIONS,modulesOptions.DONATIONS_OWN) ? 
          <ListItem>
            <ListItemButton onClick={handleDonationsTransferValidationsClick} >
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary={translate('donations_projects.reports_transfer_validations')} secondary={translate('donations_projects.reports_transfer_validations_desc')}/>
            </ListItemButton>
          </ListItem>
          : null }
          
          { subscriptionModule(modules.FEDERATION) ? 
          <ListItem>
            <ListItemButton onClick={handleDonationsPaymentsClick} >
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary={translate('donations_projects.reports_payments')} secondary={translate('donations_projects.reports_payments_desc')}/>
            </ListItemButton>
          </ListItem>
          : null }
          
          { subscriptionModule(modules.FEDERATION) || subscriptionModule(modules.DONATIONS,modules.DONATIONS_OWN) || subscriptionModule(modules.REMITTANCES) ? 
          <ListItem>
            <ListItemButton onClick={handleDonationsCertificatesClick} >
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary={translate('donations_projects.reports_certificates')} secondary={translate('donations_projects.reports_certificates_desc')}/>
            </ListItemButton>
          </ListItem>
          : null }

          { subscriptionModule(modules.FEDERATION) || subscriptionModule(modules.DONATIONS,modulesOptions.DONATIONS_OWN) || subscriptionModule(modules.REMITTANCES) ?
          <ListItem>
            <ListItemButton onClick={handleDonationsModel182Click}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary={translate('donations_model_182.title')} secondary={translate('donations_model_182.menu_description')}/>
            </ListItemButton>
          </ListItem>
          : null }
          
        </ListMaterial>
      </Box>
    
      <Dialog        
        open={openAnnuaryDialog}
        onClose={handleCloseClick}
        aria-label={translate('reports.annuary')}
      >
        <DialogTitle>{translate('reports.title')}</DialogTitle>

        <FormWithRedirect
          save={handleSubmit}
          initialValues={{ year: year, last_years: true }}
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <DialogContent>
                <br />
                {translate('reports.annuary')}
                <br /><br />
                <NumberInput label={translate('common.year')} source="year" step={1} />     
                <br /><br />
                <BooleanInput label={translate('reports.annuary_last_years')} source="last_years" />     
              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseClick} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={false}
                  label={translate('reports.generate')}
                  icon={<ListAltIcon />}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    
      <Dialog            
        fullWidth
        open={openResponsabilitiesDialog}
        onClose={handleCloseResponsabilitiesClick}
        aria-label={translate('reports.responsabilities')}
      >
        <DialogTitle>{translate('reports.title')}</DialogTitle>

        <FormWithRedirect
          save={handleResponsabilitiesSubmit}
          initialValues={{ date_query: today }}
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <DialogContent>
                <br />
                {translate('reports.responsabilities')}
                <br /><br />
                <Grid container spacing={2}>                            
                  <Grid item xs={6}> 
                    <ReferenceArrayInput 
                      reference="responsabilities" 
                      source="responsabilities"
                      sort={{ field: 'priority', order: 'ASC' }} 
                    >
                      <SelectArrayInput fullWidth source="responsabilities" label={translate('reports.responsabilities_responsability')} optionText="name" />
                    </ReferenceArrayInput>
                  </Grid>
                  <Grid item xs={6}> 
                    <DateInput fullWidth label={translate('reports.responsabilities_date')} source="date_query" />  
                  </Grid> 
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseResponsabilitiesClick} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={false}
                  label={translate('reports.generate')}
                  icon={<ListAltIcon />}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
      
      <Dialog            
        fullWidth
        open={openLeftMembersDialog}
        onClose={handleCloseLeftMembersClick}
        aria-label={translate('reports.left_members')}
      >
        <DialogTitle>{translate('reports.title')}</DialogTitle>

        <FormWithRedirect
          save={handleLeftMembersSubmit}
          initialValues={{ groups_id: Number(localStorage.getItem('members_group_id')), future: 0 }}
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <DialogContent>
                <br />
                {translate('reports.left_members')}
                <br /><br />
                <Grid container spacing={2}>                            
                  <Grid item xs={12}> 
                    <ReferenceInput label={translate('users.group')} source="groups_id" reference="groups" filter={{ associations_id : localStorage.getItem('associations_id') }} perPage={1000} >
                        <SelectInput fullWidth optionText="path" optionValue="id" validate={required()} />
                    </ReferenceInput>  
                  </Grid>
                  <Grid item xs={12}> 
                    <RadioButtonGroupInput label={translate('reports.left_members_future')} row={false} source="future" choices={[
                      { id: 0, name: translate('reports.left_members_future_0') },
                      { id: 1, name: translate('reports.left_members_future_1') }
                    ]} />
                  </Grid> 
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseLeftMembersClick} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={false}
                  label={translate('reports.generate')}
                  icon={<ListAltIcon />}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
      
      <Dialog        
        open={openDonationsPaymentsDialog}
        onClose={handleCloseDonationsCertificatesClick}
        aria-label={translate('donations_payments.title')}
      >
        <DialogTitle>{translate('donations_payments.title')}</DialogTitle>

        <FormWithRedirect
          save={handleSubmitDonationsPayments}
          initialValues={{ date_from: datesLastMonthStc.firstDayLastMonth, date_to: datesLastMonthStc.lastDayLastMonth }}
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <DialogContent>    
                <Grid container spacing={2}>                            
                  <Grid item xs={6}>                   
                    <DateInput fullWidth label={translate('donations_payments.date_from')} source="date_from" /> 
                  </Grid>
                  <Grid item xs={6}> 
                    <DateInput fullWidth label={translate('donations_payments.date_to')} source="date_to" />    
                  </Grid> 
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseDonationsPaymentsClick} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={false}
                  label={translate('donations_payments.generate')}
                  icon={<ListAltIcon />}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
      
      <Dialog        
        open={openDonationsCertificatesDialog}
        onClose={handleCloseDonationsCertificatesClick}
        aria-label={translate('donations_certificates.title')}
      >
        <DialogTitle>{translate('donations_certificates.title')}</DialogTitle>

        <FormWithRedirect
          save={handleSubmitDonationsCertificates}
          initialValues={{ year: year }}
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <DialogContent>                
                <br /><br />
                <NumberInput label={translate('common.year')} source="year" step={1} />        
              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseDonationsCertificatesClick} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={false}
                  label={translate('donations_certificates.generate')}
                  icon={<ListAltIcon />}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>

      <Dialog
        open={openDonationsModel182Dialog}
        onClose={handleCloseDonationsModel182Click}
        aria-label={translate('donations_model_182.title')}
      >
        <DialogTitle>{translate('donations_model_182.title')}</DialogTitle>
        <FormWithRedirect
          key={model182FiscalYears.join('-')}
          save={handleSubmitDonationsModel182}
          initialValues={{ year: model182FiscalYears.includes(year)
            ? year : undefined }}
          render={({ handleSubmitWithRedirect, pristine, saving }) => <>
            <DialogContent>
              {model182FiscalYearsLoading
                ? <Typography>{translate('donations_model_182.loading_fiscal_years')}</Typography>
                : model182FiscalYearsError
                  ? <Typography color="error">{model182FiscalYearsError}</Typography>
                  : <SelectInput label={translate('common.year')} source="year"
                    choices={model182FiscalYears.map(fiscalYear => ({
                      id: fiscalYear, name: fiscalYear.toString()
                    }))} validate={required()} />}
              {!model182FiscalYearsLoading && model182FiscalYears.length > 0 &&
                !model182FiscalYears.includes(year) ?
                <Typography color="error">
                  {translate('donations_model_182.previous_year_not_configured')
                    .replace('%year%', year)}
                </Typography> : null}
            </DialogContent>
            <DialogActions>
              <Button label="ra.action.cancel" onClick={handleCloseDonationsModel182Click}>
                <IconCancel />
              </Button>
              <SaveButton handleSubmitWithRedirect={handleSubmitWithRedirect}
                pristine={pristine} saving={saving}
                disabled={model182FiscalYearsLoading || model182FiscalYears.length === 0}
                label={translate('reports.generate')} icon={<ListAltIcon />} />
            </DialogActions>
          </>}
        />
      </Dialog>
      
      </>
      ) : null }
    
    </>   
    
  );
    
};

export const ReportsAnnuary = props => {
    
  const translate = useTranslate();  
  const [info, setInfo] = useState();
  const [classrooms, setClassrooms] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [errorApi, setErrorApi] = useState();
  const refresh = useRefresh(); 
  const notify = useNotify();
  const [formSent, setFormSent] = useState();
        
  const [open, setOpen] = React.useState(false);
    
  const { year: year_string, last_years: last_years_string } = parse(props.location.search);
  const year = year_string ? parseInt(year_string, 10) : '';    
  const last_years = last_years_string ? parseInt(last_years_string, 10) : '';   
            
  return (        
    <>
      <Typography variant="h5" className="grey8 mt-20 mb-20">
        {translate('reports.annuary')} {year}              
      </Typography>
      <ResourceContextProvider value="reports/annuary">
        <List              
          basePath="/reports/annuary" 
          filter={{ associations_id: localStorage.getItem('associations_id'), year: year, last_years: last_years }}
          actions={<AnnuaryActions year={year} last_years={last_years} />} 
          empty={null}   
          label=""  
          title=""  
          bulkActionButtons={false} 
          pagination={false}
          perPage={10000}
        >
          <Datagrid>                    
            <TextField source="id" label={translate('common.id')} sortable={false} />   
            <TextField source="group" label={translate('reports.annuary_item_group')} sortable={false} />   
            <TextField source="calc" label={translate('reports.annuary_item_calc')} sortable={false} />   
            <TextField source="name" label={translate('reports.annuary_item_name')} sortable={false} />     
            <NumberField source="value" label={translate('reports.annuary_item_value')} sortable={false} options={{ maximumFractionDigits: 2 }} />     
            <NumberField source="percent" label={translate('reports.annuary_item_percent')} sortable={false} options={{ maximumFractionDigits: 2 }} />   
            <NumberField source="avg" label={translate('reports.annuary_item_avg')} sortable={false} options={{ maximumFractionDigits: 2 }} />   
          </Datagrid>                            
        </List>
      </ResourceContextProvider>
    </>
        
  );
};

const AnnuaryActions = (props) => {
    
  const translate = useTranslate();
  const dataProvider = useDataProvider();    
  const notify = useNotify();
    
  let filterExport = {
    associations_id : localStorage.getItem('associations_id'), 
    year: props.year,
    last_years: props.last_years
  };
                
  return (
    <TopToolbar>        
      <ExportButton maxResults="100000" filterValues={filterExport} alwaysEnabled={true} exporter={annuaryExporter} sort={{ field: 'id', order: 'ASC' }} /> 
    </TopToolbar>
  );
};

const annuaryExporter = (items, translate, notify) => {
    
  const annuaryItemsForExport = items.map(annuaryItem => {
    var annuaryItemForExport = {
      id : annuaryItem.id,
      group : annuaryItem.group, 
      calc : annuaryItem.calc, 
      name : annuaryItem.name, 
      value : annuaryItem.value, 
      percent: annuaryItem.percent,
      avg: annuaryItem.avg,
    };
    return annuaryItemForExport;
  });
  jsonExport(annuaryItemsForExport, {
    headers: ['id', 'group', 'calc','name', 'value', 'percent','avg'],
    rename: [translate('reports.annuary_item_id'), translate('reports.annuary_item_group'), translate('reports.annuary_item_calc'), translate('reports.annuary_item_name'), translate('reports.annuary_item_value'), translate('reports.annuary_item_percent'), translate('reports.annuary_item_avg')],                
  }, (err, csv) => {
    const csv_new = '\uFEFF' + csv;
    downloadCSV(csv_new, translate('reports.annuary_exporter_file_name') ); 
    notify(translate('common.download_ok'),"success");
  });
    
};



export const ReportsResponsabilities = props => {
    
  const translate = useTranslate();  
  const [info, setInfo] = useState();
  const [classrooms, setClassrooms] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [errorApi, setErrorApi] = useState();
  const refresh = useRefresh(); 
  const notify = useNotify();
  const [formSent, setFormSent] = useState();
        
  const [open, setOpen] = React.useState(false);
    
  const { date_query: date_query_string, responsabilities: responsabilities_string } = parse(props.location.search);
  const date_query = date_query_string ? date_query_string : new Date().toLocaleDateString('en-CA');
    
  const responsabilities = responsabilities_string;
    
  return (        
    <>
      <Typography variant="h5" className="grey8 mt-20 mb-20">
        {translate('reports.responsabilities')}             
      </Typography>
      <ResourceContextProvider value="reports/responsabilities">
        <List              
          basePath="/reports/responsabilities" 
          filter={{ associations_id: localStorage.getItem('associations_id'), date_query: date_query, responsabilities: responsabilities }}
          actions={<ResponsabilitiesActions date_query={date_query} responsabilities={responsabilities} />} 
          label=""  
          title=""  
          bulkActionButtons={false}             
          perPage={25}     
          empty={<DatagridNoResults />}
        >
          <Datagrid  >                    
            <FunctionField label={translate('users.first_name')} render={record => <UserFullNameTxt record={record} /> } sortable={false} />
            <TextField source="email" label={translate('common.email')} sortable={false} /> 
            <TextField source="email_secondary" label={translate('users.email_secondary')} sortable={false} /> 
            <TextField source="responsability_name" label={translate('reports.responsabilities_responsability')} sortable={false} />                         
            <TextField source="entity_name" label={translate('reports.responsabilities_list_entity_name')} sortable={false} />   
            <TextField source="entity_city" label={translate('reports.responsabilities_list_entity_city')} sortable={false} /> 
            <DateField source="date_join" label={translate('users_groups.date_join')} sortable={false} />
            <DateField source="date_left" label={translate('users_groups.date_left')} sortable={false} />   
          </Datagrid>                            
        </List>
      </ResourceContextProvider>
    </>
        
  );
};


export const ReportsLeftMembers = props => {
    
  const translate = useTranslate();  
  const [info, setInfo] = useState();
  const [classrooms, setClassrooms] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [errorApi, setErrorApi] = useState();
  const refresh = useRefresh(); 
  const notify = useNotify();
  const [formSent, setFormSent] = useState();
        
  const [open, setOpen] = React.useState(false);
    
  const { groups_id, future } = parse(props.location.search);

  const groupsId = groups_id ? Number(groups_id) : null;
  const futureFlag = future ? Number(future) : 0;
    
  return (        
    <>
      <Typography variant="h5" className="grey8 mt-20 mb-20">
        {translate('reports.left_members')}             
      </Typography>
      <ResourceContextProvider value="reports/left_members">
        <List              
          basePath="/reports/left_members" 
          filter={{ associations_id: localStorage.getItem('associations_id'), groups_id: groupsId, future: futureFlag }}
          actions={<LeftMembersActions groups_id={groupsId} future={futureFlag} />} 
          label=""  
          title=""  
          bulkActionButtons={false}             
          perPage={25}     
          empty={<DatagridNoResults />}
        >
          <Datagrid  >                    
            <TextField source="group_name" label={translate('reports.left_members_group')} sortable={false} /> 
            <FunctionField label={translate('users.first_name')} render={record => <UserFullNameTxt record={record} /> } sortable={false} />
            <TextField source="email" label={translate('common.email')} sortable={false} /> 
            <TextField source="email_secondary" label={translate('users.email_secondary')} sortable={false} />             
            <DateField source="date_join" label={translate('users_groups.date_join')} sortable={false} />
            <DateField source="date_left" label={translate('users_groups.date_left')} sortable={false} />   
          </Datagrid>                            
        </List>
      </ResourceContextProvider>
    </>
        
  );
};


const ResponsabilitiesActions = (props) => {
    
  const translate = useTranslate();
  const dataProvider = useDataProvider();    
  const notify = useNotify();
    
  let filterExport = {
    associations_id : localStorage.getItem('associations_id'), 
    date_query: props.date_query,
    responsabilities: props.responsabilities
  };
                
  return (
    <TopToolbar>        
      <ExportButton maxResults="100000" filterValues={filterExport} alwaysEnabled={true} exporter={responsabilitiesExporter} sort={{ field: 'id', order: 'ASC' }} /> 
    </TopToolbar>
  );
};
                    
const responsabilitiesExporter = (items, translate, notify) => {
    
  const responsabilitiesItemsForExport = items.map(responsabilityItem => {
    var responsabilityItemForExport = {
      first_name : responsabilityItem.first_name,
      last_name_1 : responsabilityItem.last_name_1,
      last_name_2 : responsabilityItem.last_name_2,
      email : responsabilityItem.email,
      email_secondary : responsabilityItem.email_secondary,
      responsability_name : responsabilityItem.responsability_name,
      entity_name : responsabilityItem.entity_name,
      entity_city : responsabilityItem.entity_city,
      date_join: responsabilityItem.date_join ? responsabilityItem.date_join.substr(0,10) : '' ,
      date_left: responsabilityItem.date_left ? responsabilityItem.date_left.substr(0,10) : '' ,
    };
    return responsabilityItemForExport;
  });
  jsonExport(responsabilitiesItemsForExport, {
    headers: ['first_name', 'last_name_1', 'last_name_2','email', 'email_secondary','responsability_name', 'entity_name','entity_city','date_join','date_left'],
    rename: [translate('users.first_name'), translate('users.last_name_1'), translate('users.last_name_2'), translate('users.email'), translate('users.email_secondary'), translate('reports.responsabilities_responsability'), translate('reports.responsabilities_list_entity_name'), translate('reports.responsabilities_list_entity_city'),translate('users_groups.date_join'), translate('users_groups.date_left')],                
  }, (err, csv) => {
    const csv_new = '\uFEFF' + csv;
    downloadCSV(csv_new, translate('reports.responsabilities_exporter_file_name') ); 
    notify(translate('common.download_ok'),"success");
  });
    
};

const LeftMembersActions = (props) => {
    
  const translate = useTranslate();
  const dataProvider = useDataProvider();    
  const notify = useNotify();
    
  let filterExport = {
    groups_id : props.groups_id, 
    future: props.future
  };
                
  return (
    <TopToolbar>        
      <ExportButton maxResults="100000" filterValues={filterExport} alwaysEnabled={true} exporter={leftMembersExporter} sort={{ field: 'id', order: 'ASC' }} /> 
    </TopToolbar>
  );
};

const leftMembersExporter = (items, translate, notify) => {
    
  
  const leftMembersItemsForExport = items.map(item => {
    var leftMembersItemForExport = {
      users_id : item.users_id,
      first_name : item.first_name,
      last_name_1 : item.last_name_1,
      last_name_2 : item.last_name_2,
      email : item.email,
      email_secondary : item.email_secondary,
      group_name : item.group_name,      
      date_join: item.date_join ? item.date_join.substr(0,10) : '' ,
      date_left: item.date_left ? item.date_left.substr(0,10) : '' ,
    };
    return leftMembersItemForExport;
  });
  jsonExport(leftMembersItemsForExport, {
    headers: ['group_name', 'users_id', 'first_name', 'last_name_1', 'last_name_2','email', 'email_secondary','date_join','date_left'],
    rename: [translate('reports.left_members_group'), translate('common.id'), translate('users.first_name'), translate('users.last_name_1'), translate('users.last_name_2'), translate('users.email'), translate('users.email_secondary'), translate('users_groups.date_join'), translate('users_groups.date_left')],                
  }, (err, csv) => {
    const csv_new = '\uFEFF' + csv;
    downloadCSV(csv_new, translate('reports.left_members_exporter_file_name') ); 
    notify(translate('common.download_ok'),"success");
  });
    
};

export const ReportsDonationsProjects = props => {
    
  const translate = useTranslate();  
  const [info, setInfo] = useState();
  const [classrooms, setClassrooms] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [errorApi, setErrorApi] = useState();
  const refresh = useRefresh(); 
  const notify = useNotify();
  const [formSent, setFormSent] = useState();
        
  const [open, setOpen] = React.useState(false);
     
  return (        
    <>
      <Typography variant="h5" className="grey8 mt-20 mb-20">
        {translate('donations_projects.reports_title')  }             
      </Typography>
      
      <DonationsProjectsList {...props} />
    </>
        
  );
};

export const ReportsDonationsPayments = props => {
    
  const translate = useTranslate();  
  const [info, setInfo] = useState();
  const [classrooms, setClassrooms] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [errorApi, setErrorApi] = useState();
  const refresh = useRefresh(); 
  const notify = useNotify();
  const [formSent, setFormSent] = useState();
        
  const [open, setOpen] = React.useState(false);
          
  console.log(props);
          
  return (        
    <>
      <Typography variant="h5" className="grey8 mt-20 mb-20">
        { translate('donations_payments.reports_title').replace('%date_from%',dateOnlyToCatalan(props.match.params.date_from)).replace('%date_to%',dateOnlyToCatalan(props.match.params.date_to))  }          
      </Typography>
      
      <DonationsPaymentsList {...props} />
    </>
        
  );
};

export const ReportsDonationsCertificates = props => {
    
  const translate = useTranslate();    
  const year = props.match.params.year;
        
  return (        
    <>
      <Typography variant="h5" className="grey8 mt-20 mb-20">
        {translate('donations_certificates.title') + ' ' + year}             
      </Typography>
      
      <DonationsCertificatesList {...props} />
    </>
        
  );
};


export const ReportsDonationsTransferValidations = props => {
    
  const translate = useTranslate();  
          
  return (        
    <>
      <Typography variant="h5" className="grey8 mt-20 mb-20">
        {translate('donations_projects.reports_transfer_validations')}             
      </Typography>
      
      <DonationsUsersList {...props} />
    </>
        
  );
};
